import '../styles/main.scss';
import smoothscroll from 'smoothscroll-polyfill';
import Util from './modules/utilities';
import Sliders from './modules/Sliders';
import Menu from './modules/Menu';
import Dropdown from './modules/Dropdown';

document.addEventListener("DOMContentLoaded", () => {
  smoothscroll.polyfill();
  Util.forEachPolyfill();
  Util.anchorsInit();
  Util.externalLinksInit();
  Util.backgroundImageResize();

  Sliders.heroSlider();
  Sliders.indexAppeal();
  Sliders.singleDiary();
  Sliders.singleVoice();
  Sliders.singleCourse();

  new Menu({
    el: document.querySelector('.menu'),
    trigger: document.querySelector('.menu__toggle')
  });

  const dropdownList = document.querySelectorAll('.d-aside__item');
  dropdownList.forEach(item => new Dropdown(item));

});

window.onload = () => {
  document.body.classList.remove('loading');
};


document.getElementById("target").addEventListener("click",() => {
  document.getElementById("video-container").style.display="block";
})
document.getElementById("video-container").addEventListener("click",() => {
  document.getElementById("video-container").style.display="none";
})
